import ActionsIcon from '../../assets/icons/actions.svg?react';
import { MeetControl } from './MeetControl';

export function OptionsControl() {
	return (
		<MeetControl>
			<ActionsIcon />
		</MeetControl>
	);
}
